import { Link } from "react-router-dom";
import { useState } from "react";
import FavoriteButton from "./FavoriteButton";

const MovieCard = ({ movie }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="card group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-strong animate-slide-up"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Movie Poster Container */}
      <Link to={`/movie/${movie.id}`} className="relative overflow-hidden rounded-t-xl aspect-[2/3] block">
        <img 
          src={movie.poster} 
          alt={movie.title}
          className={`w-full h-full object-cover transition-all duration-500 ${
            isHovered ? 'scale-110' : 'scale-100'
          }`}
        />
        
        {/* Overlay with gradient */}
        <div className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-300 ${
          isHovered ? 'opacity-100' : 'opacity-60'
        }`}></div>
        
        {/* Rating Badge */}
        <div className="absolute top-3 right-3 bg-accent-500 text-white px-2 py-1 rounded-full flex items-center space-x-1 shadow-medium">
          <span className="text-sm font-bold">{movie.rating}</span>
        </div>
        
        {/* Favorite Button (Stop Propogation handled inside FavoriteButton) */}
        <div className="absolute top-3 left-3" onClick={e => e.preventDefault()}>
          <FavoriteButton movie={movie} size="sm" className="transition-all duration-300 hover:scale-110" />
        </div>
        
        {/* Year Badge */}
        <div className="absolute bottom-3 left-3 bg-black/60 backdrop-blur-sm text-white px-2 py-1 rounded-full">
          <span className="text-sm font-medium">{movie.year}</span>
        </div>
        
        {/* Play Button Overlay */}
        <div className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
          isHovered ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
        }`}>
          <div className="bg-white/90 backdrop-blur-sm rounded-full p-4 shadow-strong">
            <span className="text-2xl text-green-500">▶</span>
          </div>
        </div>
      </Link>
      
      {/* Movie Info */}
      <div className="p-4 bg-gray-900 rounded-b-xl border border-white/5">
        <h3 className="font-bold text-lg text-white mb-2 line-clamp-2 group-hover:text-orange-400 transition-colors duration-200">
          {movie.title}
        </h3>
        
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2 text-gray-300">
            <span className="text-sm font-medium">{movie.rating}</span>
          </div>
          <div className="text-gray-400 text-sm">
            {movie.year}
          </div>
        </div>
        
        {/* View Details Button */}
        <Link 
          to={`/movie/${movie.id}`}
          className="bg-orange-500 hover:bg-orange-600 text-white rounded-lg px-4 py-2 transition-colors w-full text-center block"
        >
          View Details
        </Link>
      </div>
    </div>
  );
};

export default MovieCard;
